import React, { useContext } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { getCity, getCurrency, getType } from '../../../constants'
import { Context } from '../../../Store'
import { isMobile } from 'react-device-detect'
import { BookingContext } from '../../../utils/BookingContext'

export const PropertyTitle = () => {
  const [state] = useContext(Context)
  const { hasCounteroffer } = useContext(BookingContext)
  const { i18n } = useTranslation()

  const { consumptionCosts = 0, currency = 'EUR' } = state.property
  const { value: propertyCurrency } = getCurrency(currency)
  const price = hasCounteroffer ? state.booking.counter_offer : state.property.price
  const total = hasCounteroffer
    ? state.booking.counter_offer
    : parseFloat(state.booking.prop?.tari || 0) + parseFloat(price) + parseFloat(consumptionCosts || 0)
  
    const {
    translations: { [i18n.language]: city },
  } = getCity(state.property?.city)
  const {
    translations: { [i18n.language]: type },
  } = getType(state.property?.type)

  return (
    <Grid container lg={12} md={12} sm={12} xs={12} justify='space-between' alignItems='center'>
      <Grid item style={{ overflow: 'hidden', flex: 1 }}>
        <Typography
          variant="h6"
          style={{
            fontSize: isMobile ? '14px' : '16px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {`${type} in ${state.property.street}, ${city}`}
        </Typography>
      </Grid>
      <Grid item style={{ marginLeft: '15px' }}>
        <Typography
          variant="h6"
          style={{
            fontSize: isMobile ? '14px' : '16px',
            whiteSpace: 'nowrap',
          }}
        >
          {propertyCurrency}{total}
        </Typography>
      </Grid>
    </Grid>
  )
}
